var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reporting-section" },
    [
      _c("div", { staticClass: "section-header" }, [
        _c("i", { staticClass: "material-icons section-icon" }, [
          _vm._v("library_books"),
        ]),
        _c("h2", [
          _vm._v(_vm._s(_vm.$t("dash.reporting.section.posts.title"))),
        ]),
      ]),
      !_vm.sortedPosts.length
        ? _c("div", { staticClass: "post-empty" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("inbox")]),
            _c("p", [_vm._v(_vm._s(_vm.$t("dash.reporting.no_posts")))]),
          ])
        : [
            _c(
              "div",
              { staticClass: "post-table" },
              [
                _c(
                  "div",
                  {
                    staticClass: "post-table__head",
                    style: { gridTemplateColumns: _vm.gridTemplate },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "col-header sortable",
                        class: _vm.sortClass("date"),
                        on: {
                          click: function ($event) {
                            return _vm.onSort("date")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.cap(
                                _vm.$t("dash.reporting.pdf.listItem.date")
                              )
                            )
                        ),
                        _c("i", { staticClass: "material-icons sort-icon" }, [
                          _vm._v(_vm._s(_vm.sortIcon("date"))),
                        ]),
                      ]
                    ),
                    _c("span", { staticClass: "col-header" }, [
                      _vm._v(
                        _vm._s(
                          _vm.cap(
                            _vm.$t("dash.reporting.pdf.listItem.publication")
                          )
                        )
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "col-header sortable align-right",
                        class: _vm.sortClass("impressions"),
                        on: {
                          click: function ($event) {
                            return _vm.onSort("impressions")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.cap(
                                _vm.$t("dash.reporting.pdf.listItem.print")
                              )
                            )
                        ),
                        _c("i", { staticClass: "material-icons sort-icon" }, [
                          _vm._v(_vm._s(_vm.sortIcon("impressions"))),
                        ]),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "col-header sortable align-right",
                        class: _vm.sortClass("reactions"),
                        on: {
                          click: function ($event) {
                            return _vm.onSort("reactions")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.cap(
                                _vm.$t("dash.reporting.pdf.listItem.reactions")
                              )
                            )
                        ),
                        _c("i", { staticClass: "material-icons sort-icon" }, [
                          _vm._v(_vm._s(_vm.sortIcon("reactions"))),
                        ]),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "col-header sortable align-right",
                        class: _vm.sortClass("comments"),
                        on: {
                          click: function ($event) {
                            return _vm.onSort("comments")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.cap(
                                _vm.$t("dash.reporting.pdf.listItem.comments")
                              )
                            )
                        ),
                        _c("i", { staticClass: "material-icons sort-icon" }, [
                          _vm._v(_vm._s(_vm.sortIcon("comments"))),
                        ]),
                      ]
                    ),
                    _vm.showShares
                      ? _c(
                          "span",
                          {
                            staticClass: "col-header sortable align-right",
                            class: _vm.sortClass("shares"),
                            on: {
                              click: function ($event) {
                                return _vm.onSort("shares")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.cap(
                                    _vm.$t("dash.reporting.pdf.listItem.shares")
                                  )
                                )
                            ),
                            _c(
                              "i",
                              { staticClass: "material-icons sort-icon" },
                              [_vm._v(_vm._s(_vm.sortIcon("shares")))]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.showClicks
                      ? _c(
                          "span",
                          {
                            staticClass: "col-header sortable align-right",
                            class: _vm.sortClass("clicks"),
                            on: {
                              click: function ($event) {
                                return _vm.onSort("clicks")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.cap(_vm.$t("dash.reporting.clic")))
                            ),
                            _c(
                              "i",
                              { staticClass: "material-icons sort-icon" },
                              [_vm._v(_vm._s(_vm.sortIcon("clicks")))]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "span",
                      {
                        staticClass: "col-header sortable align-right",
                        class: _vm.sortClass("engagement"),
                        on: {
                          click: function ($event) {
                            return _vm.onSort("engagement")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.cap(
                                _vm.$t("dash.reporting.pdf.listItem.engagement")
                              )
                            )
                        ),
                        _c("i", { staticClass: "material-icons sort-icon" }, [
                          _vm._v(_vm._s(_vm.sortIcon("engagement"))),
                        ]),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass:
                          "col-header sortable align-right score-header",
                        class: _vm.sortClass("score"),
                        on: {
                          click: function ($event) {
                            return _vm.onSort("score")
                          },
                        },
                      },
                      [
                        _vm._v("\n          Score"),
                        _c(
                          "span",
                          {
                            staticClass: "score-info",
                            attrs: { title: _vm.scoreFormula },
                          },
                          [_vm._v("ⓘ")]
                        ),
                        _c("i", { staticClass: "material-icons sort-icon" }, [
                          _vm._v(_vm._s(_vm.sortIcon("score"))),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._l(_vm.paginatedPosts, function (post) {
                  return _c(
                    "div",
                    {
                      key: post.id || post.post_id,
                      staticClass: "post-table__row",
                      style: { gridTemplateColumns: _vm.gridTemplate },
                    },
                    [
                      _c("span", { staticClass: "cell-date" }, [
                        _vm._v(_vm._s(_vm.formatDate(post.created_time))),
                      ]),
                      _c("div", { staticClass: "cell-post" }, [
                        _c("div", { staticClass: "post-thumb" }, [
                          post.attachment_url
                            ? _c("img", {
                                attrs: { src: post.attachment_url, alt: "" },
                              })
                            : _c("i", { staticClass: "material-icons" }, [
                                _vm._v("image"),
                              ]),
                        ]),
                        _c("div", { staticClass: "post-text" }, [
                          _c("p", { staticClass: "post-msg" }, [
                            _vm._v(_vm._s(post.message)),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "type-badge",
                              class: _vm.typeBadgeClass(post.type),
                            },
                            [_vm._v(_vm._s(_vm.typeLabel(post.type)))]
                          ),
                        ]),
                      ]),
                      _c("span", { staticClass: "cell-num" }, [
                        _vm._v(_vm._s(_vm.fmtImpression(post))),
                      ]),
                      _c("span", { staticClass: "cell-num" }, [
                        _vm._v(_vm._s(_vm.fmtReactions(post))),
                      ]),
                      _c("span", { staticClass: "cell-num" }, [
                        _vm._v(_vm._s(post.comments_count || 0)),
                      ]),
                      _vm.showShares
                        ? _c("span", { staticClass: "cell-num" }, [
                            _vm._v(_vm._s(post.shares_count || 0)),
                          ])
                        : _vm._e(),
                      _vm.showClicks
                        ? _c("span", { staticClass: "cell-num" }, [
                            _vm._v(
                              _vm._s(post.link_clicks || post.click_count || 0)
                            ),
                          ])
                        : _vm._e(),
                      _c("span", { staticClass: "cell-num" }, [
                        _vm._v(
                          _vm._s(
                            post.reach_engagement
                              ? post.reach_engagement.toFixed(2) + "%"
                              : "—"
                          )
                        ),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "cell-stars",
                          attrs: { title: _vm.scoreFormula },
                        },
                        [_vm._v(_vm._s(_vm.starsFor(post.reach_engagement)))]
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm.pageCount > 1
              ? _c("div", { staticClass: "pagination" }, [
                  _c(
                    "button",
                    {
                      staticClass: "page-btn",
                      attrs: { disabled: _vm.currentPage === 1 },
                      on: {
                        click: function ($event) {
                          _vm.currentPage--
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("chevron_left"),
                      ]),
                    ]
                  ),
                  _c("span", { staticClass: "page-info" }, [
                    _vm._v(
                      _vm._s(_vm.currentPage) + " / " + _vm._s(_vm.pageCount)
                    ),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "page-btn",
                      attrs: { disabled: _vm.currentPage === _vm.pageCount },
                      on: {
                        click: function ($event) {
                          _vm.currentPage++
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("chevron_right"),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }